// src/pages/Home.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Carousel from '../components/Carousel';
import WelcomeMessage from '../components/WelcomeMessage';
import RightPanel from '../components/RightPanel';
import useWindowSize from '../hooks/useWindowSize';
import './Home.css';

function Home() {
    const size = useWindowSize();
    const [homeData, setHomeData] = useState(null);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getHome`)
        .then((response) => {
            setHomeData(response.data);
        })
        .catch((error) => {
            console.error("There was an error fetching the data!", error);
        });
    }, []);

    if (!homeData) {
        return <div>加載中 Loading...</div>;
    }

    return (
        <div className="home-container">
            {size.width > 768 && <Carousel />}
            <div className="home-content">
                <div className="home-main-content">
                    <WelcomeMessage homepageContent={homeData.homepageContent} latestDevotion={homeData.latestDevotion} />
                </div>
                <RightPanel redirects={homeData.redirects} news={homeData.news} pastorMessage={homeData.pastorMessageContent} latestDevotion={homeData.latestDevotion} />
            </div>
        </div>
    );
}

export default Home;
